import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[integerNumber]',
})
export class IntegerNumberDirective {
  readonly VALID_KEYS = ['ArrowLeft', 'ArrowRight', 'Delete', 'Backspace'];

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    const isValid =
      /^\d*\d*$/g.test(event?.key) ||  // NOSONAR
      this.VALID_KEYS.includes(event?.key) ||
      ((event?.ctrlKey || event?.metaKey) &&
        (event?.key === 'z' ||
          event?.key === 'x' ||
          event?.key === 'c' ||
          event?.key === 'v'));

    if (!isValid) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent): void {
    const isValid = event.clipboardData
      ? /^\d*\d*$/g.test(event.clipboardData.getData('text')) // NOSONAR
      : false;

    if (!isValid) {
      event.preventDefault();
    }
  }
}
